export default __webpack_public_path__ + "5ba8bc5e1d7d84121984a7c48bd20ce2.png";